import React, { Component } from 'react';
import { render } from 'react-dom';
import Calc from './Calc';


render(<Calc />, document.getElementById('root'));
